import Select from "../Select";
import styles from "./index.css";

const ProductSelect = ({ ...rest }) => (
  <Select className={styles.productSelect} {...rest} />
);

export default ProductSelect;
